<span>
  <a
    (click)="scrollToSection()"
    [ngStyle]="{
      color: isHovering ? env['colors']['tool_btn_active'] : 'black',
    }"
    (mouseover)="isHovering = true"
    (mouseout)="isHovering = false"
  >
    {{ text }}
  </a>
</span>
